import * as actions from 'modules/marketplace/recommended/duck/actions';
import { MarketplaceProductKeys } from 'modules/marketplace/data';

export default (state = MarketplaceProductKeys.JIRA, action) => {
  switch (action.type) {
    case actions.SELECT_PRODUCT:
      return action.payload;
    default:
      return state;
  }
};
